import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { NewQuoteModal } from '@/components/crm/NewQuoteModal';
import { OfferteLijst } from '@/features/offertes/OfferteLijst';
import { useOffertelijst } from '@/features/offertes/hooks';
import { bewaarLijstAdres, filterNaarUrl, filterUitUrl, type LijstFilter } from '@/features/offertes/data/lijst';

/* /crm/quotes. De lijst zelf staat in src/features/offertes; hier alleen de gegevens,
   de filter in de URL (zodat terug van een offerte de lijst herstelt) en de dialoog
   voor een nieuwe offerte. */

export default function CRMQuotes() {
  const [searchParams, setSearchParams] = useSearchParams();
  const lijst = useOffertelijst();
  const [nieuw, setNieuw] = useState(false);

  const filter = useMemo(() => filterUitUrl(searchParams), [searchParams]);
  const zetFilter = useCallback((f: LijstFilter) => setSearchParams(filterNaarUrl(f), { replace: true }), [setSearchParams]);

  // Zodat "← Offertes" op een offerte terugkomt in deze lijst, met dit filter.
  useEffect(() => bewaarLijstAdres(searchParams.toString()), [searchParams]);

  return (
    <>
      <OfferteLijst
        offertes={lijst.data ?? []}
        laden={lijst.isPending}
        fout={lijst.error as Error | null}
        filter={filter}
        onFilter={zetFilter}
        onNieuw={() => setNieuw(true)}
      />
      <NewQuoteModal open={nieuw} onOpenChange={setNieuw} />
    </>
  );
}
